export default __webpack_public_path__ + "static/media/041-chip.d383181f.svg";